export default "__VITE_ASSET__CeZXAV4Q__"